import { render, staticRenderFns } from "./UploadImg.vue?vue&type=template&id=256f5835&scoped=true&"
import script from "./UploadImg.vue?vue&type=script&lang=ts&"
export * from "./UploadImg.vue?vue&type=script&lang=ts&"
import style0 from "./UploadImg.vue?vue&type=style&index=0&id=256f5835&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256f5835",
  null
  
)

export default component.exports